import Vue from "vue";
import VueRouter from "vue-router";

// 引入组件
import home from "../component/home/home.vue";
import mHome from "../component/home/m_home.vue";
import cases from "../component/case/case.vue";
import news from "../component/news/news.vue";
import newslist from "../component/news/newslist.vue";
import about from "../component/about/about.vue";

// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
    {
        path: "/home",
        name: 'home',
        component: home
    },
    {
        path: "/m_home",
        name: 'm_home',
        component: mHome
    },
    {
        path: "/cases",
        name: 'cases',
        component: cases
    },
    {
        path: "/news",
        name: 'news',
        component: news
    },
    {
        path: "/newslist",
        name: 'newslist',
        component: newslist
    },
    {
        path: "/about",
        name: 'about',
        component: about
    },

    // 重定向
    {
        path: '/',
        redirect: '/home'
    }
]

var router = new VueRouter({
    mode: 'history',
    routes
})
export default router;